module.exports = __webpack_public_path__ + "assets/img/20_971_big.d17073bc.jpg";